import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PanoramaHorizontalIcon(props: IconProps) {
    return <Icon {...props} iconKey={"panorama_horizontal"}/>
}
